import type { Hex, PreparedCall } from '@hoodmorning/contracts';
import { concat, encodeAbiParameters, encodeFunctionData, keccak256 } from 'viem';
import { semiModularAccountAbi } from './abis.js';

export function hashPreparedCall(call: PreparedCall): Hex {
  return keccak256(
    encodeAbiParameters(
      [
        { name: 'target', type: 'address' },
        { name: 'value', type: 'uint256' },
        { name: 'data', type: 'bytes' },
      ],
      [call.to, call.value, call.data],
    ),
  );
}

export function hashPreparedCalls(calls: readonly PreparedCall[]): Hex {
  if (calls.length === 0) return keccak256('0x');
  return keccak256(concat(calls.map(hashPreparedCall)));
}

/** Canonical SMA-B v2 execution envelope for one or more already-prepared
 * calls. This is encoding only: callers still own call admission, nonce,
 * signing, budget, simulation and submission authorization. */
export function encodeSmaBExecutionBatch(calls: readonly PreparedCall[]): Hex {
  return encodeFunctionData({ abi: semiModularAccountAbi, functionName: 'executeBatch',
    args: [calls.map(call => ({ target: call.to, value: call.value, data: call.data }))] });
}
